import {setGlobal} from '@netx/core-next/utils/setGlobal';
import AppViewsCollection from '../collections/appViews';

export const appViews = new AppViewsCollection([]);

export default appViews;

setGlobal({appViews});
